import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";

import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import img from "../../assets/img/img.png";
import Footer from "../../common/Footer";
import MediaModelApp from "./MediaModal";
import AllMediaModelApp from "./AllMediaShow";
import { getJobProfile } from "./jobListApi";

export default function MyJobProfile() {
  const { id } = useParams();
  const [hide, setHide] = useState(false);
  const [profile, setProfile] = useState({});
  const navigate = useNavigate();

  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }

  useEffect(() => {
    getJobProfile().then((res) => {
      if (res.data.data === null) {
        navigate(`/editprofile`);
        return;
      } else {
        setProfile(res.data.data);
        console.table("ll", res.data.data);
      }
    });
  }, []);
  const rowStyle = {
    display: "flex",
    alignItems: "center",
    mb: 1.5,
  };

  const labelStyle = {
    fontSize: { xs: "12px", sm: "13px", md: "16px" },
    fontWeight: 600,
    width: {sm:"150px", xs:"150px", md:'180px'}, // ⭐ alignment magic
    flexShrink: 0,
  };

  const valueStyle = {
    fontSize: { xs: "12px", sm: "13px", md: "16px" },
    fontWeight: 500,
    color: "#555",
  };

  const eduRow = {
    display: "flex",
    alignItems: "center",
    mb: 0.8,
    
  };

  const eduLabel = {
    width: "160px",
    fontWeight: 600,
    fontSize: { xs: "12px", sm: "13px", md: "16px" },
  };

  const eduValue = {
    fontSize: { xs: "12px", sm: "13px", md: "16px" },
    color: "#555",
    fontWeight: 500,
  };
  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: { sm: 3, xs: 1 } }}>
          {/* Back Icon */}
          <KeyboardBackspaceIcon
            onClick={() => navigate("/jobs")}
            sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
          />

          {/* Job Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              px: { xs: 1.5, sm: 3, md: 10, lg: 20 },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: { xs: 2, sm: 2.5, md: 3 },
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
                pb: { xs: 4, sm: 2, md:0 },
              }}
            >
              <Grid container spacing={{ sm: 10, xs: 2 }}>
                {/* Personal */}
                <Grid item xs={12} sm={6}>
                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Name :</Typography>
                    <Typography sx={valueStyle}>{profile?.name}</Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Mobile No. :</Typography>
                    <Typography sx={valueStyle}>{profile?.mobileNo}</Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Date Of Birth :</Typography>
                    <Typography sx={valueStyle}>
                      {formatDate(profile?.dateOfBirth)}
                    </Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>City :</Typography>
                    <Typography sx={valueStyle}>{profile?.city}</Typography>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Typography sx={labelStyle}>
                      Preferred Location :
                    </Typography>
                    <Typography sx={valueStyle}>{profile?.address}</Typography>
                  </Box>
                </Grid>

                {/* Designmation */}
                <Grid item xs={12} sm={6}>
                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Designation :</Typography>
                    <Typography sx={valueStyle}>
                      {profile?.designation}
                    </Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Email Id :</Typography>
                    <Typography sx={valueStyle}>{profile?.emailId}</Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Address :</Typography>
                    <Typography sx={valueStyle}>{profile?.address}</Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Gender :</Typography>
                    <Typography sx={valueStyle}>{profile?.gender}</Typography>
                  </Box>
                </Grid>
                {/* .Button */}
                <Box sx={{ mt: 1 }}>
                  <Grid
                    container
                    sx={{
                      position: "absolute",
                      bottom: { xs: 4, sm: 4, md: 20 },
                      right: { xs: 16, sm: 20 },
                      width: { xs: "40%", sm: "30%", md: "30%", lg: "20%" },
                    }}
                  >
                    <Grid item xs={12}>
                      <Button
                        onClick={() => navigate("/editprofile")}
                        fullWidth
                        variant="contained"
                        sx={{
                          backgroundColor: "#01008B",
                          // py: 1,
                          fontSize: { xs: "13px", sm: "12px", md: "18px" },

                          borderRadius: "6px",
                          textTransform: "none",
                          fontWeight: 600,
                          "&:hover": {
                            backgroundColor: "#0201b3",
                          },
                        }}
                      >
                        Edit Profile
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Box>
            {/* Edicatiom */}
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#01008B",
                  mb: 2,
                }}
              >
                Education
              </Typography>
              <Grid container spacing={3}>
                {/* card 1 */}
                {profile?.education?.map((item, index) => {
                  return (
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "10px",
                          p: 3,
                          boxShadow: "0px 4px 7.7px 0px #00000040",
                        }}
                      >
                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>Course Name :</Typography>
                          <Typography sx={eduValue}>
                            {item?.courseName}
                          </Typography>
                        </Box>

                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>
                            Institute Name :
                          </Typography>
                          <Typography sx={eduValue}>
                            {item.instituteName}
                          </Typography>
                        </Box>

                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>
                            University Name :
                          </Typography>
                          <Typography sx={eduValue}>
                            {" "}
                            {item.universityName}{" "}
                          </Typography>
                        </Box>

                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>
                            Date of Passing :
                          </Typography>
                          <Typography sx={eduValue}>
                            {" "}
                            {formatDate(item.dateOfPassing)}{" "}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex" }}>
                          <Typography sx={eduLabel}>Percentage :</Typography>
                          <Typography sx={eduValue}>
                            {" "}
                            {item.percentage}{" "}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>

            {/* .Ecperience */}

            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#01008B",
                  mb: 2,
                }}
              >
                Experience
              </Typography>
              <Grid container spacing={3}>
                {/* card 1 */}
                {profile?.experience?.map((item, index) => {
                  return (
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "10px",
                          p: 3,
                          boxShadow: "0px 4px 7.7px 0px #00000040",
                        }}
                      >
                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>Salon Name :</Typography>
                          <Typography sx={eduValue}>
                            {item.salonName}
                          </Typography>
                        </Box>

                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>From :</Typography>
                          <Typography sx={eduValue}>
                            {" "}
                            {formatDate(item.fromDate)} To{" "}
                            {formatDate(item.toDate)}
                          </Typography>
                        </Box>

                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>Designation :</Typography>
                          <Typography sx={eduValue}>
                            {" "}
                            {item.designation}{" "}
                          </Typography>
                        </Box>

                        <Box sx={eduRow}>
                          <Typography sx={eduLabel}>City :</Typography>
                          <Typography sx={eduValue}> {item.city} </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}{" "}
              </Grid>
            </Box>
            {/* .Skills */}
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Job Description */}
                  <Typography sx={eduLabel} >Skill</Typography>
                  <Typography sx={eduValue} mb={{xs:1, sm:0}}>{profile?.skills}</Typography>

                  {/* Expertise */}
                  <Typography sx={eduLabel}>Specialization</Typography>
                  <Typography sx={eduValue}>
                    {profile?.specializations}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            {/* /...Immediate */}
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: { xs: 2, sm: 2.5, md: 3 },
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container spacing={10}>
                {/* Personal */}
                <Grid item xs={12} sm={6}>
                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>
                      Immediate Available :
                    </Typography>
                    <Typography sx={valueStyle}>
                      {" "}
                      {profile?.isImmediateAvailable === true ? "Yes" : "No"}
                    </Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Current Salary :</Typography>
                    <Typography sx={valueStyle}>
                      {Number(profile?.currentSalary).toLocaleString()}/ per
                      month
                    </Typography>
                  </Box>
                </Grid>

                {/* Designmation */}
                <Grid item xs={12} sm={6}>
                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>
                      Ready to join within :
                    </Typography>
                    <Typography sx={valueStyle}>
                      {profile?.readyToJoinWithinDays}{" "}
                      {profile?.readyToJoinWithinDays === "Immediate"
                        ? ""
                        : "Days"}
                    </Typography>
                  </Box>

                  <Box sx={rowStyle}>
                    <Typography sx={labelStyle}>Expected Salary :</Typography>
                    <Typography sx={valueStyle}>
                      {Number(profile?.expectedSalary).toLocaleString()}/ per
                      month
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
